import { css } from 'goober';
import React from 'react';
import colors from '../../../styles/colors';
import font from '../../../styles/font';
import { transparentize } from '../../../styles/mixins';
const offline = css `
  font-size: ${font.fontTiny};
  background: ${transparentize(0.5, colors.white)};
  color: ${colors.white};
  border-radius: 3px;
  position: absolute;
  top: 58px;
  right: 20px;
  display: inline-block;
  padding: 2px 5px;
`;
const OfflineBadge = () => {
    return React.createElement("div", { className: offline }, "OFFLINE");
};
export default OfflineBadge;
//# sourceMappingURL=index.js.map